<template>
  <div id="table-deposit" class="table__container">
    <div class="transaction__filter--container bg-white py-2">
      <b-row class="search__export align-items-center">
        <b-col cols="11">
          <div class="d-flex pl-2">
            <b-img class="filter-image" :class="filter.sort_type == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="
                filter.sort_type == 'asc'
                  ? (filter.sort_type = 'desc')
                  : (filter.sort_type = 'asc')
                " />
            <div class="search__input w-100 pl-2 pr-0 mr-0">
              <b-input-group>
                <b-form-input v-model="filter.search" placeholder="Cari Billing" />
                <b-input-group-append is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </b-col>
        <b-col cols="1" class="px-0">
          <div>
            <b-button :disabled="isDepositRestricted" class="py-1 border-8" @click="handleTopup">
              Top Up
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-if="isLoading == true" class="d-flex justify-content-center mb-1 mt-5">
      <b-spinner label="Loading..." />
    </div>

    <vue-good-table v-else max-height="80vh" :columns="columns" :rows="rows.data" :fixed-header="false" :sort-options="{
      enabled: false,
    }" :pagination-options="{
        enabled: false,
      }">
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field === 'action'" style="display: block; width: 100%; text-align: left">
          <span>
            {{ props.column.label }}
          </span>
        </span>

        <span v-else>
          <span>
            {{ props.column.label }}
          </span>
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <!-- Column: Action -->
        <span v-if="props.column.field === 'wallet_balance'">
          <span>{{ props.row.wallet_balance | formatAmount }}</span>
        </span>

        <span v-else-if="props.column.field === 'id_card_number'">
          <span>{{ props.row.id_card_number || "-" }}</span>
        </span>

        <span v-else-if="props.column.field === 'action'">
          <div>
            <b-button :disabled="isDepositRestricted" class="bg-white border-8 px-3" @click="handleWithdraw(props.row.uuid)">
              Withdraw
            </b-button>
          </div>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>

    <div v-if="rows && isLoading == false"
      class="d-flex justify-content-between align-items-center flex-wrap bg-white border" style="padding: 0.8rem">
      <div class="d-flex align-items-center">
        <b-form-select v-model="filter.per_page" :options="['10', '15', '20']" class="mx-1" />
        <span class="text-nowrap">
          Tampilkan
          {{
            rows.total > 0 ? filter.per_page * (rows.current_page - 1) + 1 : 0
          }}
          ke
          {{
            rows.total > 0
              ? Math.min(filter.per_page * rows.current_page, rows.total)
              : 0
          }}
          dari {{ rows.total }} transaksi.
        </span>
      </div>
      <div>
        <b-row class="mx-0 align-items-center">
          <b-col>
            <pagination class="mb-0" :data="rows" :limit="4" align="right" @pagination-change-page="getData" />
          </b-col>
        </b-row>
      </div>
    </div>

    <ModalTopup :get-data="getData" :results="resultDetail" @clearForm="clearForm" />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from "lodash";
import { errorNotification } from "@/auth/utils";
import {
  BPagination,
  BFormSelect,
  VBToggle,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BButton,
  BSpinner,
  BRow,
  BCol,
} from "bootstrap-vue";

import ModalTopup from "@/components/Deposit/Modal/ModalTopup.vue";

import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormSelect,
    ModalTopup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BButton,
    BSpinner,
    BRow,
    BCol,
  },
  setup() {
    return {
      errorNotification,
    };
  },
  directives: {
    "b-toggle": VBToggle,
  },
  data() {
    return {
      is_edit: false,
      isLoading: false,
      columns: [
        {
          label: "Nama",
          field: "name",
        },
        {
          label: "No. Telepon",
          field: "phone_number",
        },
        {
          label: "No. KTP",
          field: "id_card_number",
        },
        {
          label: "Deposit",
          field: "wallet_balance",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: {},
      filter: {
        search: "",
        per_page: 10,
        sort_type: "desc",
      },
      resultDetail: {},
      resultsHistory: {}
    };
  },
  watch: {
    filter: {
      handler: _.debounce(function () {
        this.getData();
      }, 300),
      deep: true,
    },
  },
  created() {
    this.getData();
  },
  computed : {
    isDepositRestricted() {
      try {
        const permissions = JSON.parse(localStorage.getItem('userPermission') || '[]');
        return permissions.includes('batasi deposit');
      } catch (e) {
        return false;
      }
    }
  },
  methods: {
    clearForm() {
      this.resultDetail = {}
      this.resultsHistory = {}
      this.$store.commit('global/SET_WITHDRAW_HISTORIES', null)
      this.$store.commit('global/SET_NEXT_PAGE_URL', null)
      this.$store.commit('global/SET_WITHDRAW_CUSTOMER_UUID', null)
      this.$store.commit('global/SET_IS_LOADING', false)
      this.$store.commit('global/SET_PAGE', 1)
    },
    handleTopup() {
      this.$bvModal.show('modal-deposit')

      this.$store.commit('global/SET_WITHDRAW_HISTORIES', null)
      this.$store.commit('global/SET_NEXT_PAGE_URL', null)
      
      this.$store.commit('global/SET_PAGE', 1)
    },
    async handleWithdraw(uuid) {
      await this.clearForm()
      await this.topup(uuid)
      await this.getHistory(uuid)
    },
    async getHistory(uuid) {
      this.$store.commit('global/SET_WITHDRAW_CUSTOMER_UUID', uuid)
      this.$store.commit('global/SET_IS_LOADING', true)
      const queryParams = {
        customer_uuid: uuid,
      }
      try {
        const response = await this.$http.get('/wallet-transactions', {
          params: queryParams
        })
        this.$store.commit('global/SET_WITHDRAW_HISTORIES', response.data.data.data)
        this.$store.commit('global/SET_NEXT_PAGE_URL', response.data.data.next_page_url)
        
        this.$store.commit('global/SET_PAGE', response.data.data.current_page + 1)
        // this.$store.commit('global/SET_IS_LOADING', response.data.data)

        this.resultsHistory = response.data.data
      } catch (error) {
        
      } finally {
        this.$store.commit('global/SET_IS_LOADING', false)
      }
    },
    topup(uuid) {
      localStorage.customer_value = uuid;
      this.$store
        .dispatch("customer/getDetail", {
          uuid,
        })
        .then((result) => {
          this.resultDetail = result.data.data;
          this.$bvModal.show("modal-deposit");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getData(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;
      queryParams.only_have_balance = 1;
      this.$store
        .dispatch("customer/getData", {
          params: queryParams,
        })
        .then((result) => {
          this.rows = result.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response.data.meta.messages) {
            errorNotification(this, "Oops!", err.response.data.meta.messages);
          }
          this.isLoading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";

#table-deposit {
  .vgt-responsive {
    height: calc(100vh - 235px) !important;
    background-color: #fff;
  }
}
</style>
